import React from 'react'

const PriceHero = () => {
    return (
        <section
            className="py-4 position-relative"
            style={{
                overflow: 'hidden',
                background: "linear-gradient(180deg, #eaf6ff 0%, #ffffff 100%)"
            }}
        >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{
                    maxWidth: '74%',
                    zIndex: 1,
                    marginTop: 20
                }}
            >
                {/* Heading */}
                <div>
                    <h2
                        style={{
                            fontSize: "3rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.1,
                            textAlign: 'center'
                        }}
                    >
                        {/* Affordable Plans. <br />
                        Powerful Features. */}
                        Business-ready plans, built for scale
                    </h2>
                    <p
                        style={{
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            lineHeight: 1.2,
                            textAlign: 'center',
                            maxWidth: "640px",
                            margin: "0 auto"
                        }}
                    >
                        {/* Access all the tools you need to grow, with pricing that makes sense for your stage. */}
                        Automate your sales funnel and grow your business 2X with WhatsApp automation
                    </p>
                </div>
            </div>
        </section>
    )
}

export default PriceHero
